import { ConsortiumsForm } from './components/form';
import { Consortiums } from './components/table';
import { ConsortiumView } from './components/view';

import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_CONSORTIUM,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';

export const states = [
  {
    name: 'base-layout.consortiums',
    url: '/consortiums',
    component: Consortiums,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONSORTIUM, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.consortiums.create',
    url: '/new',
    component: ConsortiumsForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONSORTIUM, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.consortiums.edit',
    url: '/:consortiumId/edit',
    component: ConsortiumsForm,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONSORTIUM, PERMISSION_UPDATE]],
    },
  },
  {
    name: 'base-layout.consortiums.view',
    url: '/:consortiumId/view',
    component: ConsortiumView,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONSORTIUM, PERMISSION_READ]],
    },
  },
];
